import axios from "axios";
import { BASE_URL } from "../../../Helper/Helper";
const OrganizationState = {
  addOrganization: async (requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/create-organization`,
      requestOptions,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
      }
    );

    // console.log("response", response);
    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  getOrganization: async (params) => {
    // console.log("params", params);
    const response = await axios.get(
      `${BASE_URL}/api/v2/admin/get-organization`,
      {
        params,
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    // console.log("organization-state-res---", response);
    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  getOrganizationById: async (id) => {
    const response = await axios.get(
      `${BASE_URL}/api/v2/admin/getbyid-organization/${id}`,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    // console.log("response", response);
    let datas = response.data.data;
    // console.log("datas", datas);
    return datas;
  },

  deleteOrganization: async (id) => {
    const response = await axios.delete(
      `${BASE_URL}/api/v2/admin/delete-organization/${id}`,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  updateOrganization: async (id, requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.put(
      `${BASE_URL}/api/v2/admin/update-organization/${id}`,
      requestOptions,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
      }
    );

    // console.log("res", response);
    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  updateOrganizationyById: async (id, updatedFiles) => {
    // FETCH API CALL For all files
    await axios.put(
      `${BASE_URL}/api/v2/admin/single-organization/${id}`,
      updatedFiles,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
      }
    );
  },

  updateOrganizationFields: async (id, requestOptions) => {
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/organization-fields/${id}`,
      requestOptions,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  updateOrganizationSocialLink: async (id, requestOptions) => {
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/organization-social/${id}`,
      requestOptions,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  updateOrganizationStatus: async (id, requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/update-organization-status/${id}`,
      requestOptions,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },
};

export default OrganizationState;
